/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Watery_Kind_Lizard_AdviseInputs */

const fr_watery_kind_lizard_advise = /** @type {(inputs: Watery_Kind_Lizard_AdviseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clôturer la discussion`)
};

/**

* @param {Watery_Kind_Lizard_AdviseInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const watery_kind_lizard_advise = /** @type {((inputs?: Watery_Kind_Lizard_AdviseInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Watery_Kind_Lizard_AdviseInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_watery_kind_lizard_advise(inputs)
});